<script setup lang="ts">
defineProps<{
  title?: string
  description?: any
  useMask?: boolean | null
  image?: Media | null
  maskedMedia?: MaskedMedia | null
}>()
</script>

<template>
  <section class="px-1 flex flex-col gap-1 container-d">
    <h2 v-if="title" class="text-md">{{ title }}</h2>

    <div 
      v-if="image?.id || maskedMedia?.id"
    >
      <core-maskable-media
        :use-mask="useMask"
        :image="image"
        :masked-media="maskedMedia"
      />
    </div>

    <div v-if="hasRichTextContent(description)">
      <core-rich-text :content="description" />
    </div>
  </section>
</template>
